namespace $.$$ {

	$mol_style_define( $bog_vmap_app_inspect_row, {

		font: { family: 'monospace' },

		Label: {
			color: $mol_theme.text,
		},

	} )

}
